import React from 'react'

import { ButtonClean, ToolbarButton } from '@fourthwall/components'
import { DownloadIcon } from '@fourthwall/icons'

type DownloadButtonProps = {
  type: 'icon' | 'text'
  onDownload: () => Promise<void>
}

export const DownloadButton = ({ type, onDownload }: DownloadButtonProps) => {
  const [isDownloading, setIsDownloading] = React.useState(false)

  const handleDownload = async () => {
    setIsDownloading(true)
    await onDownload()
    setIsDownloading(false)
  }

  if (type === 'icon') {
    return (
      <ToolbarButton
        isLoading={isDownloading}
        disabled={isDownloading}
        label="Download"
        icon={DownloadIcon}
        onClick={handleDownload}
      />
    )
  }

  return (
    <ButtonClean
      label={isDownloading ? 'Downloading...' : 'Download'}
      icon={DownloadIcon}
      appearance="secondary"
      disabled={isDownloading}
      onClick={handleDownload}
    />
  )
}
